module.exports = require('./helpers/bundle-url').getBundleURL('aqzUD') + "logo-dark.eefe0b7f.svg";